var React = require('react');
var Frame = require('../../views/Frame');

var spritesHelper = require('../../../lib/spritesHelper');

var Audio = require('../../../lib/audio');

var BucketFullFrame = React.createClass({

    propTypes: {
        index: React.PropTypes.number,
        intensity: React.PropTypes.number,
        play: React.PropTypes.bool,
        storyWidth: React.PropTypes.number,
        storyHeight: React.PropTypes.number,
        width: React.PropTypes.number,
        height: React.PropTypes.number,
        border: React.PropTypes.number,
        objs: React.PropTypes.object,
        container: React.PropTypes.object
    },

    sprites: null,
    pixiFlux: null,
    audios: null,

    getDefaultProps: function()
    {
        return {
            texts: [
                {
                    title: '',
                    subtitle: null,
                    opts: {
                        align: 'center',
                        y: 200,
                        titleStyle: {
                            fontWeight: 'bold',
                            fontSize: '50px',
                            fontFamily: 'Oswald',
                            lineHeight: 50
                        }
                    }
                }
            ],
            className: 'bucket-full-frame',
            fluxSettings: require('../../../flux/bucketFullFrame'),
            audioUrls: {
                filling: '/audio/28nov/regulation-cuve-remplissage-02.mp3'
            }
        }
    },

    render: function()
    {
        return (
            <Frame
                onBuild={this.build}
                onPlay={this.play}
                onPause={this.pause}
                onDestroy={this.destroy}
                onIntensityChanged={this.updateIntensity}
                {...this.props}
            />
        );
    },

    build: function(container, timeline, opts)
    {
        this.sprites = {
            container: container
        };

        this.pixiFlux = opts.pixiFlux;

        this.buildObjects();

        this.audios = {};
        _.forOwn(this.props.audioUrls, _.bind(function(value, key){
            this.audios[key] = new Audio(value, {
                loop: true,
                channel: 'frame'
            });
        }, this));
    },

    play: function()
    {
        if (this.audios.filling) {
            this.audios.filling.play({
                fade: true
            });
        }

    },

    pause: function()
    {
        if (this.audios.filling) {
            this.audios.filling.pause({
                fade: true
            });
        }
    },

    destroy: function()
    {
        if (this.audios.filling) {
            this.audios.filling.destroy();
            this.audios.filling = null;
        }

        if (this.sprites) {
            Object.keys(this.sprites).forEach(key => (
                TweenMax.killTweensOf(this.sprites[key])
            ));
        }

        this.sprites = null;
        this.audios = null;
    },

    buildObjects: function()
    {
        var props = this.props;
        var context = this.context;
        var sprites = this.sprites;
        var minIntensity = context.minIntensity;
        var maxIntensity = context.maxIntensity;
        var objs = props.objs;
        var container = sprites.container;

        var i, movieclipProp, movieclipObject, movieclip;

        // flux
        var fluxMask = spritesHelper.createFrameMaskFromSize(props.width, props.height * 0.86);

        var fluxContainer = new PIXI.Container();
        if (this.pixiFlux) {
            this.pixiFlux.setContainer(fluxContainer, props.width);
        }

        fluxContainer.mask = fluxMask;
        container.addChild(fluxMask);
        container.addChild(fluxContainer);
    }

});

module.exports = BucketFullFrame;



// WEBPACK FOOTER //
// ./js/components/frames/_common/BucketFullFrame.jsx